import { AbstractSubmitStep } from "@component/assets/AbstractLeadForm/Steps/AbstractSubmitStep";
import {
	faBullseye as fasBullseye,
	faFlagCheckered as fasFlagCheckered,
	faArrowRight as fasArrowRight,
} from "@awesome.me/kit-3777c2145e/icons/classic/solid";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import autobind from "autobind-decorator";
import { FormCurrency, FormSelect, FormTeaor, ProgressButton } from "bm-ui-kit";
import type { FormApi } from "final-form";
import type { ReactNode } from "react";
import React from "react";
import { Card } from "react-bootstrap";
import { LOAN_GOALS } from "./Step6.data";

export interface StepFields {
	loanGoal: string;
	loanAmount: number;
	companyMainActivity: string;
	rentalYearly: number;
}

export class Step6 extends AbstractSubmitStep<StepFields> {
	protected renderContent(values: StepFields, form: FormApi<StepFields>): ReactNode {
		const { submitState } = this.props;
		const disabled = this.isDisabled();

		return (
			<>
				<Card.Body>
					<FormSelect
						label="Hitelcél:"
						name="loanGoal"
						placeholder="Válaszd ki a hitelcélt"
						prepend={<FontAwesomeIcon icon={fasBullseye} />}
						options={LOAN_GOALS}
						disabled={disabled}
						required
					/>
					<FormCurrency
						label="Mekkora hitelt szeretnél?"
						name="loanAmount"
						validate={this.validLoanAmount}
						disabled={disabled}
						required
					/>
					<FormTeaor
						label="Fő tevékenység:"
						name="companyMainActivity"
						prepend={<FontAwesomeIcon icon={fasFlagCheckered} />}
						placeholder="Add meg céged fő tevékenységét"
						disabled={disabled}
						required
					/>
					{values.loanGoal === "SELA_R_ESTATE" && (
						<FormCurrency
							label="Ha bérelt ingatlan helyett vásárolnál saját ingatlant, mekkora a jelenleg bérelt ingaltan éves bérleti díja?"
							name="rentalYearly"
							validate={this.validRentalYearly}
							disabled={disabled}
						/>
					)}
				</Card.Body>
				<Card.Footer className="text-center">
					<ProgressButton
						type="submit"
						icon={<FontAwesomeIcon icon={fasArrowRight} />}
						className={!form.getState().valid ? "disabled" : undefined}
						state={submitState}
					>
						Tovább
					</ProgressButton>
				</Card.Footer>
			</>
		);
	}

	@autobind
	private validLoanAmount(loanAmount: number): string {
		if (!loanAmount || loanAmount <= 0) {
			return "Kérjük, add meg az igényelt hitelösszeget!";
		}
	}

	@autobind
	private validRentalYearly(rentalYearly: number): string {
		if (rentalYearly < 0) {
			return "Az éves bérleti díj nem lehet negatív!";
		}
	}

	protected getComponentName(): string {
		return "Step6";
	}
}
